export default __webpack_public_path__ + "static/media/educator-banner-vi.42f4b667.webp";